module.exports = __webpack_public_path__ + "static/media/title_1.0598f69d.svg";